export default __webpack_public_path__ + "static/media/snam-logo-white.d1d09ec0.png";